import script from "./edit-user-tag.vue?vue&type=script&lang=tsx&setup=true"
export * from "./edit-user-tag.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__